import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditLeadInput } from '../../../../shared/models/lead/editLead.Input';
import { LeadIdInput } from '../../../../shared/models/lead/leadId.input';
import { EventService } from '../../../../shared/services/event/event.service';
import { LeadService } from '../../../../shared/services/lead/lead.service';
import { StylesProvider } from '../../../../shared/services/utils/styles.provider';
import { ToastService } from '../../../../shared/services/utils/toast.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { LeadsComunicationService } from '../../../leads/leads-comunication.service';
import { ModalsHandlerService } from '../../../modals/modals.handler.service';
import { TemplateLeadFormComponent } from '../template-lead-form-component';

@Component({
  selector: 'ngx-edit-lead-modal',
  templateUrl: '../template-lead-form.html'
})

export class EditLeadFormComponent extends TemplateLeadFormComponent implements OnInit {
  editLeadInput: EditLeadInput = new EditLeadInput();
  leadId: string;
  newModal: boolean;
  editModal: boolean;
  comingFromEditForm = true;

  constructor(
    protected leadComunicationService: LeadsComunicationService,
    protected modalsHandler: ModalsHandlerService,
    protected modalService: NgbModal,
    protected toasterService: ToastService,
    protected readonly leadService: LeadService,
    protected styleProvider: StylesProvider,
    private readonly translatorService: TranslatorService,
    protected formBuilder: FormBuilder,
    protected eventService: EventService,
  ) {
    super(
      leadComunicationService,
      leadService,
      modalsHandler,
      modalService,
      toasterService,
      formBuilder,
      styleProvider,
      eventService
    );
    this.modalEmitter = this.modalsHandler.editLeadModal;

    this.newModal = false;
    this.editModal = true;
  }

  ngOnInit() {
    super.ngOnInit();
    this.canSubmitOrigin();
  }

  launchQuery(): void {
    this.editLeadInput.lead = this.lead;
    this.editLeadInput.leadId = this.leadId;
    const toasterSuccess = { title: 'toaster.edit.lead.success', body: 'toaster.edit.lead.success.body' };
    const toasterError = { title: 'toaster.edit.lead.error', body: 'toaster.edit.lead.error.body' };
    this.subscribeMe(this.leadService.editLead$(this.editLeadInput), toasterSuccess, toasterError, this.leadId);
  }

  getLead(data: string): void {
    this.zipCode = '';
    const leadIdInput = new LeadIdInput();
    leadIdInput.leadId = data;
    this.leadService.getLeadById$(leadIdInput).subscribe(result => {
      this.brandSelected = result.lead.brand;
      this.channelSelected = result.lead.channel;
      this.dealerSelected = result.lead.dealer;
      this.typeSelected = {
        id: result.lead.type,
        name: this.translatorService.trans(`pages.leads.type.${result.lead.type}`)
      };
      this.originSelected = result.lead.origin;

      this.zipCode = `${result.lead.postalCode} ${result.lead.location}`.trim();

      const lead = result.getLead();
      this.lead = lead.getLeadForm();
      this.lead.location = lead.location;
      this.lead.postalCode = lead.postalCode;
      this.lead.address = lead.address;
      this.leadId = lead.id;

      this.leadForm.patchValue(this.lead);
      this.originBlocked = false;
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

}
